import styled from 'styled-components';
export var Footer = styled.div.withConfig({
  displayName: "partials__Footer",
  componentId: "sc-qi76oc-0"
})(["position:relative;margin-top:-10px;", ""], function (_ref) {
  var flex = _ref.flex;
  return flex && "\n  display: flex;\n  flex-direction: column;\n";
});